import React from 'react'

export const ModalHeader = ({ title, close }) => {
  return (
    <div className="w-100 relative mb4 flex bg-op-con-dark op-con-light f7 ph4 pv3">
      <div>{title}</div>
      <span className="w-40 mr-auto" />
      <div className="tc f6 nowrap pointer" onClick={close}>
        X
      </div>
    </div>
  )
}

export const Modal = ({ children }) => {
  return (
    <div className="modal-window">
      {children}
      <div className="overlay"></div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Modal.js